export default __webpack_public_path__ + "static/media/phone.592f637e.jpg";